module.exports = __webpack_public_path__ + "pc/img/main_work_img7.f6cad16d.jpg";